export default __webpack_public_path__ + "static/media/x-delete.f1b645c8.svg";